export const stringToOption = (value: string) => ({ label: value, value });

export const optionToString = (option: { value: string }) => option.value;

export const optionsFromEnum = (e: Record<string, string>) => Object.values(e).map(stringToOption);
